<template>
    <div class="col-6">
        <div class="card">
            <div class="card-body">
                <div class="dropdown float-right">
                    <a href="#" class="dropdown-toggle card-drop" data-toggle="dropdown">
                        <i class="fas fa-ellipsis-v"/>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-right" x-placement="bottom-end">
                        <li>
                            <a href="" @click.prevent="showCarrierAreaModal()" class="dropdown-item">
                                <i class="fa fa-edit mr-1"/>
                                <span v-html="$t('CarrierAreaInfoCard.edit')"/>
                            </a>
                        </li>
                    </ul>
                </div>
                <h4 class="header-title m-t-0">
                    <i class="fas fa-globe mr-1"/>
                    <span v-html="$t('CarrierAreaInfoCard.carrierAreaInfo')"/>
                </h4>
                <hr/>
                <p><b v-html="$t('CarrierAreaInfoCard.name')"/>: <span v-html="carrierArea.name"/></p>
                <p><b v-html="$t('CarrierAreaInfoCard.margin')"/>: <span v-html="carrierArea.marginLabel()"/></p>
                <p>
                    <b v-html="$t('CarrierAreaInfoCard.associatedDestinations')"/>:
                    <span v-if="!carrierArea.destinations.length" v-html="$t('CarrierAreaInfoCard.noAssociatedDestinations')"/>
                    <span v-else>
                        <router-link v-for="destination in carrierArea.destinations" :to="`/billing/carrier-destination/${destination.id}`"
                                     :key="destination.id" v-tooltip="destination.country.name" class="ml-1">
                            <img alt="flag" width="30" :src="getDiceBaseUrl() + destination.country.flagURL" class="shadow"/>
                        </router-link>
                    </span>
                </p>
            </div>
        </div>
        <CarrierAreaFormModal @editCarrierArea="editCarrierArea" ref="CarrierAreaFormModal" :carrier="carrier"/>
    </div>
</template>

<script>
import CarrierAreaFormModal from "../../../shared/Billing/CarrierArea/CarrierAreaFormModal";
export default {
    name: "CarrierAreaInfoCard",
    components: { CarrierAreaFormModal },
    props: {
        carrier: {
            type: Object,
            required: true,
        },
        carrierArea: {
            type: Object,
            required: true,
        },
    },
    methods: {
        showCarrierAreaModal() {
            this.$refs.CarrierAreaFormModal.show(this.carrierArea);
        },
        editCarrierArea(carrierArea) {
            this.$emit("editCarrierArea", carrierArea);
        },
        getDiceBaseUrl() {
            return this.$diceAPI.getBaseUrl();
        },
    },
};
</script>

<style scoped>

</style>